import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { InventoryGatewayService } from '../../services/gateway/inventory.gateway.service';
import * as CategoryActions from './ticket-categories.actions';

@Injectable()
export class TicketCategoriesEffects {
  // When loadTicketCategoriesByStore action is called -> call the inventory gateway get the categories for that store
  loadByStore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryActions.loadTicketCategoriesByStore),
      mergeMap(({ storeId }) =>
        this.gateway.listCategoriesByStore(storeId).pipe(
          // on success -> dispatch success action
          map((cats) => CategoryActions.loadTicketCategoriesByStoreSuccess({ storeId, categories: cats })),
          // on failure -> dispatch failure action
          catchError((err) => of(CategoryActions.loadTicketCategoriesByStoreFailure({ error: err.message })))
        )
      )
    )
  );

  // Φόρτωση όλων των κατηγοριών
  loadAllCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoryActions.loadAllTicketCategories),
      mergeMap(() =>
        this.gateway.listAllCategories().pipe(
          // Σε επιτυχία, αποστέλλουμε την ενέργεια επιτυχίας
          map((categories) => CategoryActions.loadAllTicketCategoriesSuccess({ categories })),
          // Σε αποτυχία, αποστέλλουμε την ενέργεια αποτυχίας
          catchError((err) => of(CategoryActions.loadAllTicketCategoriesFailure({ error: err.message })))
        )
      )
    )
  );

  constructor(private actions$: Actions, private gateway: InventoryGatewayService) {}
}
